import { DashboardApiOrigin, TabletApiOrigin } from '@/lib/restClient/apiPath';

export const DASHBOARD_API_ORIGIN = process.env
  .REACT_APP_API_ORIGIN as DashboardApiOrigin;

export const TABLET_API_ORIGIN = process.env
  .REACT_APP_TABLET_API_ORIGIN as TabletApiOrigin;

export const MICRO_CMS_API_ORIGIN = process.env
  .REACT_APP_MICRO_CMS_API_ORIGIN as string;

export const MICRO_CMS_API_KEY = process.env
  .REACT_APP_MICRO_CMS_API_KEY as string;

// process.env.NODE_ENV の 'production' がstgの環境でも使われているようなので下記で対応
export const isProd = TABLET_API_ORIGIN === 'https://api.camel.kitchen';

// MOS機能を公開する企業IDリスト。本番と非本番でリストを分けているのは、
// 検証用のIDが誤って本番の別企業へアクセス権を与えてしまうのを防ぐためです。
// 本番へ公開する際に下記のコメントを外します。
const MOS_PRODUCTION_ENTERPRISE_IDS: number[] = [
  // 5643, // MOS本番アカウント
];
const MOS_NON_PRODUCTION_ENTERPRISE_IDS: number[] = [
  5425, // MOS検証用アカウント
];

export const MOS_ENTERPRISE_IDS = isProd
  ? MOS_PRODUCTION_ENTERPRISE_IDS
  : MOS_NON_PRODUCTION_ENTERPRISE_IDS;

// 拠点一覧に代理ログインの導線「タブレット画面を開く」を表示する企業IDリスト。
// 発行の可否は camel-golang-backend の代理ログイン発行APIの許可リストが決めます。
// 2つがずれると、導線が出るのに発行が 403 になるか、発行できるのに導線が出ないため、
// 公開先を変える時は camel-golang-backend の許可リストも同じ内容に変えます。
// 本番へ公開する際に下記のコメントを外します。
const PROXY_LOGIN_PRODUCTION_ENTERPRISE_IDS: number[] = [
  // 5643, // MOS本番アカウント
];
const PROXY_LOGIN_NON_PRODUCTION_ENTERPRISE_IDS: number[] = [
  5425, // MOS検証用アカウント
];

export const PROXY_LOGIN_ENTERPRISE_IDS = isProd
  ? PROXY_LOGIN_PRODUCTION_ENTERPRISE_IDS
  : PROXY_LOGIN_NON_PRODUCTION_ENTERPRISE_IDS;

// 一括品切れV2を本番で公開する企業IDリスト
// 全企業に公開する際はこの制限を削除する
export const BULK_SOLDOUT_V2_ENTERPRISE_IDS: number[] = [
  180, // 株式会社サンマルクカフェ
  3846, // KFC
  5408, // 壱番屋BPOテストアカウント
  5496, // 株式会社壱番屋
  5437, // ファーストキッチン
  5603, // 喜代村
  4006, // スターバックス
  113, // クリスピー・クリーム・ドーナツ・ジャパン（KKDJ）
  375, // フロジャポン（フロ プレステージュ）
  2103, // ドトール（パンの田島）
  5669, // 株式会社治元
];
